import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { 
  Box, 
  Typography, 
  TextField, 
  Button, 
  Select, 
  MenuItem, 
  InputLabel, 
  FormControl, 
  CircularProgress,
  Alert,
  Card,
  CardContent,
  Grid,
  Link
} from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Navbar from "components/Navbars/AuthNavbar.js";

const EditRequestForm = () => {
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    telephone: "",
    montantDemande: "",
    projetDescription: "",
    pays: "",
    ville: "",
    devise: "",
    homeproof: null,
    idcard: null,
    currentHomeproof: "",
    currentIdcard: "",
    sexe: "",
    adresse: "",
    typeAide: "",
    dateNaissance:""
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const history = useHistory();

  const pays = [
    "Luxembourg", "Irlande", "Singapour", "Norvège", "Qatar", "Bermudes", 
    "Suisse", "Émirats arabes unis", "Îles Caïmans", "Danemark", 
    "États-Unis d'Amérique", "Pays-Bas", "Islande", "Autriche", "Brunei", 
    "Hong Kong", "Belgique", "Suède", "Allemagne", "Australie", "Finlande", 
    "Canada", "Bahreïn", "Macao", "Arabie saoudite", "Malte", "Koweït", 
    "France", "Royaume-Uni", "Italie", "Nouvelle-Zélande", "Israël", 
    "Tchèque", "Corée du Sud", "Slovénie", "Lituanie", "Sint Maarten", 
    "Aruba", "Espagne", "Estonie", "Japon", "Pologne", "Portugal", 
    "Hongrie", "Roumanie", "Croatie", "Guyana", "Oman", "Lettonie", 
    "Slovaquie",
  ];

  const typesAide = [
    "Aide financière non remboursable",
    "Bourse familiale",
    "Aides aux personnes âgées",
    "Soutiens financier à la création",
    "Aide financière non remboursable avec assurances",
    "Bourse familiale avec assurances",
    "Aides aux personnes âgées avec assurances",
    "Soutiens financier à la création avec assurances"
  ];

  const devises = [
    "EUR", "SGD", "NOK", "QAR", "USD", "CHF", "AED", "DKK",
    "ISK", "BND", "HKD", "SEK", "AUD", "CAD", "BHD", "SAR", "KWD", 
    "GBP", "NZD", "ILS", "CZK", "KRW", "ANG", "AWG", "JPY", 
    "PLN", "HUF", "RON", "HRK", "GYD", "OMR", "SKK",
  ];
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        const response = await axios.get("https://appapi.unpaidfinancial.com/api/me", {
          headers: { Authorization: `Bearer ${token}` }
        });

        setFormData({
          ...response.data,
          currentHomeproof: response.data.homeproof,
          currentIdcard: response.data.idcard,
          homeproof: null,
          idcard: null,
          
        });

      } catch (err) {
        setError("Erreur lors du chargement des données");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setFormErrors(prev => ({ ...prev, [name]: "" }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    
    if (file && file.size > 10 * 1024 * 1024) {
      setFormErrors(prev => ({ ...prev, [name]: "Fichier trop volumineux (max 10Mo)" }));
      return;
    }
    
    const validTypes = ['image/jpeg', 'image/png'];
    if (file && !validTypes.includes(file.type)) {
      setFormErrors(prev => ({ ...prev, [name]: "Format JPG/PNG seulement" }));
      return;
    }

    setFormData(prev => ({ ...prev, [name]: file }));
    setFormErrors(prev => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.nom) errors.nom = "Champ obligatoire";
    if (!formData.prenom) errors.prenom = "Champ obligatoire";
    if (!formData.telephone) errors.telephone = "Champ obligatoire";
    if (!formData.montantDemande) errors.montantDemande = "Champ obligatoire";
    if (!formData.projetDescription) errors.projetDescription = "Champ obligatoire";
    if (!formData.pays) errors.pays = "Champ obligatoire";
    if (!formData.ville) errors.ville = "Champ obligatoire";
    if (!formData.devise) errors.devise = "Champ obligatoire";
    if (!formData.typeAide) errors.typeAide = "Champ obligatoire";
    if (!formData.dateNaissance) errors.dateNaissance = "Champ obligatoire";
    if (!formData.sexe) errors.sexe = "Champ obligatoire";
    if (!formData.adresse) errors.adresse = "Champ obligatoire";




    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('_method', 'PUT');

      const editableFields = [
        'nom', 'prenom', 'telephone', 'montantDemande', 
        'projetDescription', 'pays', 'ville', 'devise',
        'sexe', 'adresse', 'typeAide','dateNaissance'
      ];

      editableFields.forEach(field => {
        formDataToSend.append(field, formData[field]);
      });

      if (formData.homeproof) formDataToSend.append('homeproof', formData.homeproof);
      if (formData.idcard) formDataToSend.append('idcard', formData.idcard);

      const token = localStorage.getItem('accessToken');
      await axios.post("https://appapi.unpaidfinancial.com/api/update-request", formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      setSuccess("Votre demande a été mise à jour avec succès");
      setError("");
      setTimeout(() => history.push("/me/statut"), 2000);
      
    } catch (err) {
      setError(err.response?.data?.message || "Erreur lors de la mise à jour");
      setSuccess("");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    history.push("/me/statut");
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      
      <Box sx={{ 
        
        minHeight: '200px',
        pt: 8,
        pb: 12,
        position: 'relative'
      }}>
        <Typography 
          variant="h3" 
          component="h1" 
          align="center" 
          color="primary"
          sx={{ fontWeight: 'bold', mb: 2 }}
        >
          Modifier ma demande
        </Typography>
      </Box>

      <Box sx={{ 
        position: 'relative',
        maxWidth: '1200px',
        mx: 'auto',
        mt: -8,
        px: { xs: 2, sm: 3 },
        mb: 8
      }}>
        <Card elevation={6} sx={{ borderRadius: 4 }}>
          <CardContent sx={{ p: { xs: 3, md: 6 } }}>
            {error && (
              <Alert severity="error" sx={{ mb: 4 }}>
                {error}
              </Alert>
            )}
            
            {success && (
              <Alert severity="success" sx={{ mb: 4 }}>
                {success}
              </Alert>
            )}

            <form onSubmit={handleSubmit}>
              <Grid container spacing={4}>
                {/* Nom et Prénom */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Nom"
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    error={!!formErrors.nom}
                    helperText={formErrors.nom}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Prénom"
                    name="prenom"
                    value={formData.prenom}
                    onChange={handleChange}
                    error={!!formErrors.prenom}
                    helperText={formErrors.prenom}
                    variant="outlined"
                  />
                </Grid>

<Grid item xs={12} md={6}>
  <TextField
    fullWidth
    label="Date de naissance"
    name="dateNaissance"
    type="date"
    value={formData.dateNaissance || ""}
    onChange={handleChange}
    error={!!formErrors.dateNaissance}
    helperText={formErrors.dateNaissance}
    InputLabelProps={{ shrink: true }}
    variant="outlined"
  />
</Grid>
<Grid item xs={12} md={6}>
  <FormControl fullWidth error={!!formErrors.sexe}>
    <InputLabel>Sexe</InputLabel>
    <Select
      name="sexe"
      value={formData.sexe}
      onChange={handleChange}
      label="Sexe"
    >
      <MenuItem value=""><em>Sélectionnez</em></MenuItem>
      <MenuItem value="Homme">Homme</MenuItem>
      <MenuItem value="Femme">Femme</MenuItem>
      <MenuItem value="Autre">Autre</MenuItem>
    </Select>
    {formErrors.sexe && (
      <Typography variant="caption" color="error">
        {formErrors.sexe}
      </Typography>
    )}
  </FormControl>
</Grid>

<Grid item xs={12}>
  <TextField
    fullWidth
    label="Adresse résidentielle"
    name="adresse"
    value={formData.adresse}
    onChange={handleChange}
    error={!!formErrors.adresse}
    helperText={formErrors.adresse}
    variant="outlined"
  />
</Grid>


                {/* Email (lecture seule) */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Email"
                    value={formData.email}
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                    }}
                    helperText="L'email ne peut pas être modifié"
                  />
                </Grid>

                {/* Téléphone */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Téléphone"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleChange}
                    error={!!formErrors.telephone}
                    helperText={formErrors.telephone}
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12}>
  <FormControl fullWidth error={!!formErrors.typeAide}>
    <InputLabel>Type d'aide</InputLabel>
    <Select
      name="typeAide"
      value={formData.typeAide}
      onChange={handleChange}
      label="Type d'aide"
    >
      <MenuItem value=""><em>Sélectionnez</em></MenuItem>
      {typesAide.map((option, i) => (
        <MenuItem key={i} value={option}>{option}</MenuItem>
      ))}
    </Select>
    {formErrors.typeAide && (
      <Typography variant="caption" color="error">
        {formErrors.typeAide}
      </Typography>
    )}
  </FormControl>
</Grid>


                {/* Montant et Devise */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Montant demandé"
                    name="montantDemande"
                    type="number"
                    value={formData.montantDemande}
                    onChange={handleChange}
                    error={!!formErrors.montantDemande}
                    helperText={formErrors.montantDemande}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth error={!!formErrors.devise}>
                    <InputLabel>Devise</InputLabel>
                    <Select
                      name="devise"
                      value={formData.devise}
                      onChange={handleChange}
                      label="Devise"
                    >
                      {devises.map((d, i) => (
                        <MenuItem key={i} value={d}>{d}</MenuItem>
                      ))}
                    </Select>
                    {formErrors.devise && (
                      <Typography variant="caption" color="error">
                        {formErrors.devise}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>

                {/* Description */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Description du projet"
                    name="projetDescription"
                    value={formData.projetDescription}
                    onChange={handleChange}
                    error={!!formErrors.projetDescription}
                    helperText={formErrors.projetDescription}
                    variant="outlined"
                    multiline
                    rows={4}
                  />
                </Grid>

                {/* Pays et Ville */}
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth error={!!formErrors.pays}>
                    <InputLabel>Pays</InputLabel>
                    <Select
                      name="pays"
                      value={formData.pays}
                      onChange={handleChange}
                      label="Pays"
                    >
                      {pays.map((p, i) => (
                        <MenuItem key={i} value={p}>{p}</MenuItem>
                      ))}
                    </Select>
                    {formErrors.pays && (
                      <Typography variant="caption" color="error">
                        {formErrors.pays}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Ville"
                    name="ville"
                    value={formData.ville}
                    onChange={handleChange}
                    error={!!formErrors.ville}
                    helperText={formErrors.ville}
                    variant="outlined"
                  />
                </Grid>

               

                {/* Boutons */}
                <Grid item xs={12}>
                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'flex-end',
                    gap: 2,
                    mt: 4
                  }}>
                    <Button
                      variant="outlined"
                      onClick={handleCancel}
                      disabled={loading}
                      sx={{ px: 4, py: 1.5 }}
                    >
                      Annuler
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={loading}
                      sx={{ px: 4, py: 1.5 }}
                      startIcon={loading ? <CircularProgress size={20} /> : null}
                    >
                      {loading ? 'Enregistrement...' : 'Enregistrer'}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default EditRequestForm;